import React from 'react';
import logo from '../../assets/sp-logo-white.png';
import styles from './auth-layout.module.sass';
import Panel from '../Panel';
import { Typography, Row, Col } from 'antd';

export function SPLinks() {
  const { Text } = Typography;

  return (
    <div className={styles.sp_links}>
      <Text>
        <a target="_blank" href="https://www.silentpush.com/">
          silentpush.com
        </a>
      </Text>
      <Text className={styles.circle}>•</Text>
      <Text>
        <a
          target="_blank"
          href="https://silentpush.atlassian.net/servicedesk/customer/portals"
        >
          Support
        </a>
      </Text>
      <Text className={styles.circle}>•</Text>
      <Text>
        <a target="_blank" href="https://www.silentpush.com/terms-of-use">
          Terms Of Service
        </a>
      </Text>
      <Text className={styles.circle}>•</Text>
      <Text>
        <a target="_blank" href="https://www.silentpush.com/privacy-policy">
          Privacy Policy
        </a>
      </Text>
    </div>
  );
}

function AuthLayout({ style, children, title, description, error }) {
  const { Text, Title } = Typography;

  return (
    <Row
      className={styles.auth_layout}
      gutter={24}
      align="middle"
      justify="center"
    >
      <Col xs={24} md={13} lg={10} xl={9} xxl={7}>
        <Panel bgcolor={'#1C3138'} className={styles.forgotPasswordPanel}>
          <img
            alt={'silentpush logo'}
            title="SilentPush Logo"
            src={logo}
            width={250}
          />
          <Title level={2}>{title}</Title>
          <Text className={styles.info}>{description}</Text>
          {error && <Text className={styles.error}>{error}</Text>}

          <div>{children}</div>
        </Panel>

        <SPLinks />
      </Col>
    </Row>
  );
}

export default AuthLayout;
